import * as React from 'react';
export var IcArrowRight = function () { return (React.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement("path", { d: 'M12 4.28723L10.59 5.69723L16.17 11.2872H4V13.2872H16.17L10.59 18.8772L12 20.2872L20 12.2872L12 4.28723Z' }))); };
